import { Box, Image, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { enrolledPath } from "@outschool/routes";
import {
  CopyToClipboard,
  uiContextIds,
} from "@outschool/ui-components-website";
import { Space } from "@outschool/ui-legacy-component-library";
import { Screen } from "@outschool/ui-utils";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import shareGiftEnrollmentImage from "../../../images/monitor-class-celebration.png";
import * as Routes from "../../../shared/Routes";
import Link from "../Link";

const GiftInvitationsModalBackgroundCircle = () => (
  <svg role="presentation" viewBox="0 0 100 100" style={{ margin: "-1em" }}>
    <circle
      r="100"
      cx="50"
      cy="140"
      style={{ fill: "rgba(43, 167, 206, 0.05)" }}
    />
  </svg>
);

export default function GiftInvitationsModal({
  sectionUid,
  giftEnrollmentCount,
  acceptGiftSlugId,
}: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\enrolling\\GiftInvitationsModal",
  );
  const isMobile = Screen.useIsMobile();
  return (
    <Box
      sx={{
        display: "grid",
        alignItems: "center",

        "> *": {
          gridColumnStart: 1,
          gridRowStart: 1,
        },
      }}
    >
      {!isMobile && <GiftInvitationsModalBackgroundCircle />}
      <Box
        flex
        sx={{
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h2">{t`Gift Invitations`}</Typography>
        <Space y="medium" />
        <Image
          src={shareGiftEnrollmentImage}
          alt={t`Send Gift Invitations`}
          sx={{
            width: "67%",
          }}
        />
        <Space y="large" />
        <Box
          sx={{
            fontWeight: "fontWeightMedium",
          }}
        >
          {t(
            "Send this link to the invitees. (You purchased {{giftEnrollmentCount}} gift enrollment)",
            {
              giftEnrollmentCount,
              count: giftEnrollmentCount,
              defaultValue_plural:
                "Send this link to the invitees. (You purchased {{giftEnrollmentCount}} gift enrollments)",
            },
          )}
        </Box>
        <Space y="medium" />
        <Box
          sx={{
            width: "100%",
          }}
        >
          <CopyToClipboard
            inputValue={Routes.giftEnrollmentUrl(acceptGiftSlugId)}
            copyButtonLabel={t("Copy Link")}
            // eslint-disable-next-line i18next/no-literal-string
            buttonVariant="contained"
            trackingName="gift_enrollment_invite_modal_share_link"
            uiContextId={uiContextIds.GiftInvitationsModal}
          />
        </Box>
        <Space y="small" />
        <Link to={enrolledPath(sectionUid)}>{t`I’ll Do It Later`}</Link>
      </Box>
    </Box>
  );
}
